
module.directive('step', function() {
    return {
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
            if (!ngModel) return;

            var step = parseFloat(attrs.step);
            var decimals = -1 * Math.floor(Math.log(step) / Math.log(10));

            ngModel.$validators.step = function(value) {
                if (angular.isDefined(value)) {
                    return value % 1 === 0 ||
                        ("" + value).split(".")[1].length <= decimals;
                }
                return true;
            };
        }
    };
});

module.directive('sameAs', function() {
    return {
        require: '?ngModel',
        scope: {other: '=sameAs'},
        link: function(scope, element, attrs, ngModel) {
            if (!ngModel) return;
            scope.$watch('other', function(n, o) {
                ngModel.$validate();
            });
            ngModel.$validators.sameAs = function(modelValue) {
                return modelValue === scope.other;
            };
        },
    };
});

module.directive('validateCurrency', function() {
    return {
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {

            var allow_cents = angular.isDefined(attrs.allow_cents);
            var currency_regex = /^(\$?\-?\d{1,3}(,?\d{1,3})*(\.\d\d)?|\.\d\d)$/;
            var invalid_chars = /[^0-9\.\-]/g;

            ngModel.$parsers.unshift(function(viewValue) {
                if (currency_regex.test(viewValue)) {
                    ngModel.$setValidity('currency', true);
                    var val = parseFloat(viewValue.replace(invalid_chars, ""));
                    if (!allow_cents) {
                        return parseInt(val);
                    }
                    return val;
                } else {
                    ngModel.$setValidity('currency', false);
                    return undefined;
                }
            });
        }
    };
});




